import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Plus, X, Edit, Power } from 'lucide-react';

export default function Employees() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState(null); // {new} or user
  const [form, setForm] = useState({});

  const load = useCallback(async () => { try { const r = await api.get('/users'); setUsers(r.data); } catch { toast.error('Acesso negado'); } }, []);
  useEffect(() => { load(); }, [load]);

  const openNew = () => { setForm({ username: '', password: '', name: '', role: 'employee', commission_pct: 0 }); setModal({ new: true }); };
  const openEdit = (u) => { setForm({ ...u, password: '' }); setModal(u); };

  const save = async () => {
    try {
      if (modal.new) {
        await api.post('/users', form);
        toast.success('Funcionário criado');
      } else {
        const upd = { name: form.name, role: form.role, commission_pct: Number(form.commission_pct) || 0 };
        if (form.password) upd.password = form.password;
        await api.put(`/users/${modal.id}`, upd);
        toast.success('Atualizado');
      }
      setModal(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Erro'); }
  };

  const toggle = async (u) => { await api.put(`/users/${u.id}`, { active: !u.active }); load(); };

  return (
    <div className="p-4 h-full overflow-y-auto space-y-3">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-black">Funcionários</h2>
        <button onClick={openNew} data-testid="user-new" className="h-9 px-4 rounded-xl bg-orange-500 text-white font-bold text-sm flex items-center gap-1"><Plus size={16}/> Novo</button>
      </div>
      <div className="space-y-2">
        {users.map((u) => (
          <div key={u.id} className={`bg-white rounded-xl border border-slate-200 p-3 flex items-center gap-3 ${!u.active ? 'opacity-50' : ''}`} data-testid={`user-row-${u.id}`}>
            <div className="flex-1">
              <div className="font-bold">{u.name}</div>
              <div className="text-xs text-slate-500">@{u.username} · {u.role} · Comissão {u.commission_pct}%</div>
            </div>
            <button onClick={() => openEdit(u)} className="w-9 h-9 rounded-lg bg-slate-100 grid place-items-center"><Edit size={16}/></button>
            <button onClick={() => toggle(u)} className={`w-9 h-9 rounded-lg grid place-items-center ${u.active ? 'bg-amber-50 text-amber-600' : 'bg-green-50 text-green-600'}`}><Power size={16}/></button>
          </div>
        ))}
      </div>

      {modal && (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center sm:justify-center" onClick={() => setModal(null)}>
          <div onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-4 space-y-3">
            <div className="flex justify-between"><div className="font-black">{modal.new ? 'Novo funcionário' : 'Editar'}</div><button onClick={() => setModal(null)}><X/></button></div>
            {modal.new && <input placeholder="Usuário" value={form.username} onChange={(e) => setForm({...form, username: e.target.value})} data-testid="user-username" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>}
            <input placeholder="Nome" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} data-testid="user-name" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <input type="password" placeholder={modal.new ? "Senha" : "Nova senha (opcional)"} value={form.password} onChange={(e) => setForm({...form, password: e.target.value})} data-testid="user-password" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <select value={form.role} onChange={(e) => setForm({...form, role: e.target.value})} data-testid="user-role" className="w-full h-11 rounded-xl border border-slate-200 px-3">
              <option value="employee">Funcionário</option>
              <option value="admin">Administrador</option>
            </select>
            <input type="number" placeholder="Comissão %" value={form.commission_pct} onChange={(e) => setForm({...form, commission_pct: e.target.value})} data-testid="user-commission" className="w-full h-11 rounded-xl border border-slate-200 px-3"/>
            <button onClick={save} data-testid="user-save" className="w-full h-12 rounded-xl bg-orange-500 text-white font-black">Salvar</button>
          </div>
        </div>
      )}
    </div>
  );
}
